/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiContractorPenaltiesCreateContractorPenaltyPost } from '../fn/contractor-penalty/api-contractor-penalties-create-contractor-penalty-post';
import { ApiContractorPenaltiesCreateContractorPenaltyPost$Params } from '../fn/contractor-penalty/api-contractor-penalties-create-contractor-penalty-post';
import { apiContractorPenaltiesCreateContractorPenaltyPost$Plain } from '../fn/contractor-penalty/api-contractor-penalties-create-contractor-penalty-post-plain';
import { ApiContractorPenaltiesCreateContractorPenaltyPost$Plain$Params } from '../fn/contractor-penalty/api-contractor-penalties-create-contractor-penalty-post-plain';
import { apiContractorPenaltiesDeleteContractorPenaltyDelete } from '../fn/contractor-penalty/api-contractor-penalties-delete-contractor-penalty-delete';
import { ApiContractorPenaltiesDeleteContractorPenaltyDelete$Params } from '../fn/contractor-penalty/api-contractor-penalties-delete-contractor-penalty-delete';
import { apiContractorPenaltiesDeleteContractorPenaltyDelete$Plain } from '../fn/contractor-penalty/api-contractor-penalties-delete-contractor-penalty-delete-plain';
import { ApiContractorPenaltiesDeleteContractorPenaltyDelete$Plain$Params } from '../fn/contractor-penalty/api-contractor-penalties-delete-contractor-penalty-delete-plain';
import { apiContractorPenaltiesGetContractorPenaltiesPost } from '../fn/contractor-penalty/api-contractor-penalties-get-contractor-penalties-post';
import { ApiContractorPenaltiesGetContractorPenaltiesPost$Params } from '../fn/contractor-penalty/api-contractor-penalties-get-contractor-penalties-post';
import { apiContractorPenaltiesGetContractorPenaltiesPost$Plain } from '../fn/contractor-penalty/api-contractor-penalties-get-contractor-penalties-post-plain';
import { ApiContractorPenaltiesGetContractorPenaltiesPost$Plain$Params } from '../fn/contractor-penalty/api-contractor-penalties-get-contractor-penalties-post-plain';
import { CreateContractorPenaltyCommandResult } from '../models/create-contractor-penalty-command-result';
import { DeleteContractorPenaltyCommandResult } from '../models/delete-contractor-penalty-command-result';
import { GetContractorPenaltiesQueryResult } from '../models/get-contractor-penalties-query-result';

@Injectable({ providedIn: 'root' })
export class ContractorPenaltyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiContractorPenaltiesGetContractorPenaltiesPost()` */
  static readonly ApiContractorPenaltiesGetContractorPenaltiesPostPath = '/api/ContractorPenalties/GetContractorPenalties';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContractorPenaltiesGetContractorPenaltiesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContractorPenaltiesGetContractorPenaltiesPost$Plain$Response(params?: ApiContractorPenaltiesGetContractorPenaltiesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContractorPenaltiesQueryResult>> {
    return apiContractorPenaltiesGetContractorPenaltiesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContractorPenaltiesGetContractorPenaltiesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContractorPenaltiesGetContractorPenaltiesPost$Plain(params?: ApiContractorPenaltiesGetContractorPenaltiesPost$Plain$Params, context?: HttpContext): Observable<GetContractorPenaltiesQueryResult> {
    return this.apiContractorPenaltiesGetContractorPenaltiesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContractorPenaltiesQueryResult>): GetContractorPenaltiesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContractorPenaltiesGetContractorPenaltiesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContractorPenaltiesGetContractorPenaltiesPost$Response(params?: ApiContractorPenaltiesGetContractorPenaltiesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContractorPenaltiesQueryResult>> {
    return apiContractorPenaltiesGetContractorPenaltiesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContractorPenaltiesGetContractorPenaltiesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContractorPenaltiesGetContractorPenaltiesPost(params?: ApiContractorPenaltiesGetContractorPenaltiesPost$Params, context?: HttpContext): Observable<GetContractorPenaltiesQueryResult> {
    return this.apiContractorPenaltiesGetContractorPenaltiesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetContractorPenaltiesQueryResult>): GetContractorPenaltiesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiContractorPenaltiesCreateContractorPenaltyPost()` */
  static readonly ApiContractorPenaltiesCreateContractorPenaltyPostPath = '/api/ContractorPenalties/CreateContractorPenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContractorPenaltiesCreateContractorPenaltyPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiContractorPenaltiesCreateContractorPenaltyPost$Plain$Response(params?: ApiContractorPenaltiesCreateContractorPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateContractorPenaltyCommandResult>> {
    return apiContractorPenaltiesCreateContractorPenaltyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContractorPenaltiesCreateContractorPenaltyPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiContractorPenaltiesCreateContractorPenaltyPost$Plain(params?: ApiContractorPenaltiesCreateContractorPenaltyPost$Plain$Params, context?: HttpContext): Observable<CreateContractorPenaltyCommandResult> {
    return this.apiContractorPenaltiesCreateContractorPenaltyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateContractorPenaltyCommandResult>): CreateContractorPenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContractorPenaltiesCreateContractorPenaltyPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiContractorPenaltiesCreateContractorPenaltyPost$Response(params?: ApiContractorPenaltiesCreateContractorPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateContractorPenaltyCommandResult>> {
    return apiContractorPenaltiesCreateContractorPenaltyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContractorPenaltiesCreateContractorPenaltyPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiContractorPenaltiesCreateContractorPenaltyPost(params?: ApiContractorPenaltiesCreateContractorPenaltyPost$Params, context?: HttpContext): Observable<CreateContractorPenaltyCommandResult> {
    return this.apiContractorPenaltiesCreateContractorPenaltyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateContractorPenaltyCommandResult>): CreateContractorPenaltyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiContractorPenaltiesDeleteContractorPenaltyDelete()` */
  static readonly ApiContractorPenaltiesDeleteContractorPenaltyDeletePath = '/api/ContractorPenalties/DeleteContractorPenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContractorPenaltiesDeleteContractorPenaltyDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContractorPenaltiesDeleteContractorPenaltyDelete$Plain$Response(params?: ApiContractorPenaltiesDeleteContractorPenaltyDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteContractorPenaltyCommandResult>> {
    return apiContractorPenaltiesDeleteContractorPenaltyDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContractorPenaltiesDeleteContractorPenaltyDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContractorPenaltiesDeleteContractorPenaltyDelete$Plain(params?: ApiContractorPenaltiesDeleteContractorPenaltyDelete$Plain$Params, context?: HttpContext): Observable<DeleteContractorPenaltyCommandResult> {
    return this.apiContractorPenaltiesDeleteContractorPenaltyDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteContractorPenaltyCommandResult>): DeleteContractorPenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContractorPenaltiesDeleteContractorPenaltyDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContractorPenaltiesDeleteContractorPenaltyDelete$Response(params?: ApiContractorPenaltiesDeleteContractorPenaltyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteContractorPenaltyCommandResult>> {
    return apiContractorPenaltiesDeleteContractorPenaltyDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContractorPenaltiesDeleteContractorPenaltyDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiContractorPenaltiesDeleteContractorPenaltyDelete(params?: ApiContractorPenaltiesDeleteContractorPenaltyDelete$Params, context?: HttpContext): Observable<DeleteContractorPenaltyCommandResult> {
    return this.apiContractorPenaltiesDeleteContractorPenaltyDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteContractorPenaltyCommandResult>): DeleteContractorPenaltyCommandResult => r.body)
    );
  }

}
